module.exports = __webpack_public_path__ + "04_glasses_red.ef7fd2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer4/04_glasses_red.png
// module id = oP/e
// module chunks = 0